import styled from 'styled-components';

export const divInfor = styled.div` 
display:flex;
flex-direction:column;
width:95vw ;
max-width:500px ;
min-width:270px ;
font-size: clamp(13px, 3vw, 14px);

span{
color: white;
}

input{
width:100%;
border:none;
background:none;
color: white;
margin-top:5px;
margin-bottom:5px;
color: #00D594;
outline:0;
padding-left: 5px ;

::placeholder{
  text-transform:lowercase ;
}
}

.abrirModal{
  display:flex;
  margin: 3px 0;
  align-items: center ;
  justify-content: center ;
  border-radius:1px;
  padding: 8px 5px;
  cursor:pointer ;
  background-color: #3881ff ;
  color: white ;
}

.selectData{
  display:flex;
  flex-direction: column ;
  min-width: 88px;

  select{
    background-color:#30353f ;
    border:none;
    border-radius:5px ;
    height: 25px ;
    margin-top:0 ;
    outline:0;
    padding-left: 5px;
    color: white;
  }
  option{
    color: #00D594;
  }

  input{
    background-color:#30353f ;
    border-radius:5px ;
    height: 20px ;
    margin-top:0 ;

  }
}

.filtrosLinha{
  display: flex;
  gap: 10px;
  margin-bottom: 5px;
}

.filtrosDataGroup{
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  gap: 10px;
  
}

.datasInicioFim{
  display: flex;
  gap: 10px;
}

@media (max-width: 450px) {
  .filtrosDataGroup{
    flex-direction: column;
    gap: 6px;
    width: 100%;
  }

  .tipoDataBox{
    width: 100%;
  }

  .tipoDataBox select{
    width: 100%;
  }

  .datasInicioFim{
    width: 100%;
    gap: 6px;
  }

  .datasInicioFim .selectData{
    flex: 1;
    min-width: 0;
  }
}
`

// ---------------------
export const boxInfor = styled.div`
display: flex;
flex-direction:column;


`
export const ddd = styled.div`
display: flex;
flex-direction:row;
background-color: #30353f ;
padding: 3px 0 ;

input{
  text-transform:uppercase ;
}

`
// ------------------------------------------
export const divPesq = styled.div` 
display:flex;
width:100% ;
flex-direction: column ;
align-items: center ;
background-color: #262626 ;
margin: 10px 0 0 0;



input{
    color: white ;
    border:none;
    background:none;
    outline:0;
    background-color: #353535 ;
    text-transform:uppercase ;
    margin-bottom:0;
    
    @media (max-width: 450px) {
      font-size: clamp(12px, 3vw, 14px);
    }
  }
`
// ----------------------------------
export const Pesq = styled.div`
display:flex;
justify-content:center;
align-items: center ;

button{
  background:none;
  border:none;
  outline:0;
  &:hover{
    background:none;
}}
img{
  width:17px;
  height:17px;
  cursor: pointer;

  &:hover{
    opacity: 0.5;
  }}

`


export const result = styled.div`
display:flex;
background-color: ${props =>
    props.eventoLista === 'E' ? '#ff8787' : props.eventoLista === 'I' ? '#ffecaa' : '#efefef'
  }; 
align-items: center ;
justify-content: center ;
color:black;
border-radius:2px;
margin:5px 0;
padding:2px 0; ;

.checkbox{
  display:flex;
  align-self:center;
}
span{
  display:flex;
  flex:1;
  justify-content:space-between;
  align-items:center;
}

.editar{
  display:flex;
  align-self:center;
  width:17px;
  height:17px;
  margin: 0 3px;
  cursor: pointer;
}

`
export const botao = styled.div` 
display:flex;
`
export const checked = styled.div` 
display:flex;
align-items: start ;
margin:0 ;

span{
  display: flex ;
  white-space:nowrap ;
  font-weight:620 ;
}

`
// -----------------------------------
export const divListaBD = styled.div`
display: flex ;
z-index: 1;

`

